module.exports = __webpack_public_path__ + "media/feelingBetter2.be5eaa25.mp3";